// Code generated by tygo. DO NOT EDIT.
/* eslint-disable */
/* prettier-ignore */
import type * as core from "../../../core/wire/core.gen"

//////////
// source: agents.go

/**
 * AgentInherit is an item's own setting when it says nothing itself: the folder above decides.
 */
export const AgentInherit = "inherit";
/**
 * ItemAgentsView answers GET and PUT /api/drive/items/{key}/agents: an item's setting for AI chats
 * as a team member of its drive reads it in Who can open. Own is what the item says itself
 * (AgentInherit or a level); Effective what Claude gets, the lowest level on the path; Source the
 * place that lowest level comes from — the item itself, a folder above it, or the drive's top
 * (Drive) —; SetBy and SetAt who chose the item's own setting and when (absent when nobody did), and
 * OnBehalf, for a setting Claude's move kept, the person who asked for the move. Pinned marks that
 * setting, PinnedFrom the place the item left — absent once a person has moved the item into another
 * drive, whose readers may not know that place, or the place is gone. Max is the most the item may be set to — its folder's
 * effective, the drive's top's at the top —, and Holds counts what a folder holds below it, every
 * level down, which its setting reaches too.
 */
export interface ItemAgentsView {
	own: string;
	effective: string;
	source: AgentSource;
	setBy?: number /* int64 */;
	setAt?: number /* int64 */;
	onBehalf?: number /* int64 */;
	pinned?: boolean;
	pinnedFrom?: AgentSource;
	max: string;
	holds?: AgentHolds;
}
/**
 * AgentSource is a place a setting comes from, by its key and its name: a folder or an item, or a
 * drive (Drive), whose name is empty for My drive and for Team until renamed — the browser words
 * those for its reader, as it does a breadcrumb's first step.
 */
export interface AgentSource {
	key: string;
	name: string;
	drive?: boolean;
}
/**
 * AgentHolds counts the live items below a folder, every level down: what its setting reaches.
 */
export interface AgentHolds {
	documents: number /* int */;
	folders: number /* int */;
	files: number /* int */;
}
/**
 * ItemAgentsSet is the body of PUT /api/drive/items/{key}/agents: AgentInherit, or one of the four
 * levels, which may not be above the item's folder's effective setting (409 drive.item.agents.above
 * with the most it may be, {max}).
 */
export interface ItemAgentsSet {
	setting: string;
}
/**
 * SpaceAgentsSet is the body of PUT /api/drive/spaces/{key}/agents, the drive's two settings for AI
 * chats in one action: Open — false closes the drive to AI chats, so Claude finds nothing in it, true
 * opens it again with every setting as it was — or Setting, the drive's top's level (one of the four;
 * never inherit, since nothing stands above the top), or Open true with a Setting, which opens a
 * closed drive at that level in one write. Closing takes no level.
 */
export interface SpaceAgentsSet {
	open?: boolean;
	setting?: string;
}
/**
 * AdminAgentsList answers GET /api/admin/drive/agents, the Drive part of the administrators' page
 * Open to AI chats: every drive closed to AI chats or whose top is not at write or was set by
 * somebody, then every live
 * folder, document and file whose own setting is not inherit, folders first. Default counts the
 * drives left out of both — open and at write, as every drive starts, with nothing in them saying
 * otherwise.
 * A name stands only where the administrator is in the drive — an administrator is not in a drive by
 * being one —, in the words SpaceView's names take (a worded name for My drive and Team); elsewhere
 * the key alone, which is what an administrator asks the drive's people about.
 */
export interface AdminAgentsList {
	drives: AdminAgentsDrive[];
	items: AdminAgentsItem[];
	default: number /* int */;
}
/**
 * AdminAgentsDrive is one drive of the administrators' list: its key, its name where the
 * administrator is in it, whether it is somebody's My drive, its top's level, and who set it and
 * when; for a drive closed to AI chats, who closed it and when — the top's level then waits, kept,
 * for the drive to open again, and the list names the drive as closed.
 */
export interface AdminAgentsDrive {
	key: string;
	name?: string;
	personal?: boolean;
	setting: string;
	setBy?: number /* int64 */;
	setAt?: number /* int64 */;
	closed?: boolean;
	closedBy?: number /* int64 */;
	closedAt?: number /* int64 */;
}
/**
 * AdminAgentsItem is one item of the administrators' list: its key and kind, its drive by key (and
 * by name where the administrator is in it, with the item's name and the folders above it), its own
 * setting with who set it and when, and for a setting Claude's move kept the person who asked
 * (Pinned, OnBehalf).
 */
export interface AdminAgentsItem {
	key: string;
	kind: string;
	drive: string;
	driveName?: string;
	name?: string;
	path?: string[];
	setting: string;
	setBy?: number /* int64 */;
	setAt?: number /* int64 */;
	onBehalf?: number /* int64 */;
	pinned?: boolean;
}

//////////
// source: batches.go

/**
 * The kinds of a batch.
 */
export const BatchDirect = "direct";
/**
 * The kinds of a batch.
 */
export const BatchProposal = "proposal";
/**
 * The states of a batch: a direct batch is done until undone; a proposal is open until people apply
 * or discard it, or Claude withdraws every act, and an applied one may be undone.
 */
export const BatchDone = "done";
/**
 * The states of a batch: a direct batch is done until undone; a proposal is open until people apply
 * or discard it, or Claude withdraws every act, and an applied one may be undone.
 */
export const BatchOpen = "open";
/**
 * The states of a batch: a direct batch is done until undone; a proposal is open until people apply
 * or discard it, or Claude withdraws every act, and an applied one may be undone.
 */
export const BatchApplied = "applied";
/**
 * The states of a batch: a direct batch is done until undone; a proposal is open until people apply
 * or discard it, or Claude withdraws every act, and an applied one may be undone.
 */
export const BatchDiscarded = "discarded";
/**
 * The states of a batch: a direct batch is done until undone; a proposal is open until people apply
 * or discard it, or Claude withdraws every act, and an applied one may be undone.
 */
export const BatchWithdrawn = "withdrawn";
/**
 * The states of a batch: a direct batch is done until undone; a proposal is open until people apply
 * or discard it, or Claude withdraws every act, and an applied one may be undone.
 */
export const BatchUndone = "undone";
/**
 * The acts of a batch (AgentActView.Op): a new folder, a move, a rename, a trash and a restore, the
 * words drive_agent_act.op stores.
 */
export const ActFolder = "folder";
/**
 * The acts of a batch (AgentActView.Op): a new folder, a move, a rename, a trash and a restore, the
 * words drive_agent_act.op stores.
 */
export const ActMove = "move";
/**
 * The acts of a batch (AgentActView.Op): a new folder, a move, a rename, a trash and a restore, the
 * words drive_agent_act.op stores.
 */
export const ActRename = "rename";
/**
 * The acts of a batch (AgentActView.Op): a new folder, a move, a rename, a trash and a restore, the
 * words drive_agent_act.op stores.
 */
export const ActTrash = "trash";
/**
 * The acts of a batch (AgentActView.Op): a new folder, a move, a rename, a trash and a restore, the
 * words drive_agent_act.op stores.
 */
export const ActRestore = "restore";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const OutcomeApplied = "applied";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const OutcomeSkipped = "skipped";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const OutcomeLeftOut = "left_out";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const OutcomeDiscarded = "discarded";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const OutcomeWithdrawn = "withdrawn";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const ReasonChanged = "changed";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const ReasonGone = "gone";
/**
 * The outcome of a proposed act once people decided (AgentActView.Outcome), and why an act was
 * skipped by an apply or an undo (AgentSkip.Reason): ReasonChanged — somebody changed the item or a
 * place it names since —, ReasonGone — the item or a place it names is gone, trashed or no longer in
 * the batch's drive —, ReasonRefused — the person may not make the act.
 */
export const ReasonRefused = "refused";
/**
 * What an undo did with each act it reverted (AgentActView.Undo), read from the undo's own change rows:
 * UndoBack — the item is back as it was —, UndoStayed — it stayed, because somebody changed it since
 * or it is gone. Never stored: every read derives them.
 */
export const UndoBack = "back";
/**
 * What an undo did with each act it reverted (AgentActView.Undo), read from the undo's own change rows:
 * UndoBack — the item is back as it was —, UndoStayed — it stayed, because somebody changed it since
 * or it is gone. Never stored: every read derives them.
 */
export const UndoStayed = "stayed";
/**
 * AgentBatchView is one batch as a reader of the drive sees it: its key and drive, its kind and state,
 * the chat that made it — named (Chat) and Yours only for a reader who can open that chat, who sees an
 * open proposal's band —, who asked and when, Claude's note to a proposal as Claude wrote it, the
 * counts by act, who decided and who undid it, and, on the read of one batch, its acts.
 */
export interface AgentBatchView {
	key: string;
	spaceId: number /* int64 */;
	kind: string;
	state: string;
	chat?: ChatRef;
	yours: boolean;
	askedBy: number /* int64 */;
	at: number /* int64 */;
	note?: string;
	counts: AgentCounts;
	decided?: BatchMark;
	undone?: BatchMark;
	acts?: AgentActView[];
}
/**
 * ChatRef names an AI chat to a reader who can open it: its title and its address.
 */
export interface ChatRef {
	label: string;
	url: string;
}
/**
 * AgentCounts counts a batch's acts by what they do: new folders, moves, renames, trashes, restores.
 * A proposal counts its open acts while open and its applied ones after; a direct batch its changes.
 */
export interface AgentCounts {
	folders: number /* int */;
	moved: number /* int */;
	renamed: number /* int */;
	trashed: number /* int */;
	restored: number /* int */;
}
/**
 * BatchMark is who decided or undid a batch, and when.
 */
export interface BatchMark {
	by: number /* int64 */;
	at: number /* int64 */;
}
/**
 * AgentActView is one act of a batch: its number, what it does, the item (a purged item by its key
 * alone; absent for a new folder not made yet), where it was and where it goes by key — a drive's key
 * for its top —, or ToAct, the number of the proposed folder it goes into; the new name of a rename
 * and a new folder; Keeps, the setting for AI chats a move keeps (the pin), which the review says; for
 * a decided proposal what became of the act and why; Stale, for an open act, the reason an apply now
 * would skip it (its item or a place it names changed or went since Claude proposed it), so the review
 * says so before anybody applies; and Undo, for an undone batch's act, whether it is back or stayed.
 */
export interface AgentActView {
	n: number /* int */;
	op: string;
	item?: AgentItem;
	fromKey?: string;
	toKey?: string;
	toAct?: number /* int */;
	name?: string;
	keeps?: string;
	outcome?: string;
	reason?: string;
	stale?: string;
	undo?: string;
}
/**
 * AgentItem is the item an act names: its key, its name (empty once purged) and its kind.
 */
export interface AgentItem {
	key: string;
	name?: string;
	kind: string;
}
/**
 * AgentBatches answers GET /api/drive/spaces/{key}/changes?before=<id>: a drive's batches, open
 * proposals first, then newest first, a page at a time; Next is the before of the next page.
 */
export interface AgentBatches {
	batches: AgentBatchView[];
	next?: number /* int64 */;
}
/**
 * ApplyBatch is the body of POST /api/drive/changes/{batch}/apply: the numbers of the acts people
 * kept checked; every other open act is left out.
 */
export interface ApplyBatch {
	acts: number /* int */[];
}
/**
 * AgentBatchResult answers apply, discard and undo: the batch as it now stands, how many acts were
 * applied or undone, the acts skipped with why, and how many were left out.
 */
export interface AgentBatchResult {
	batch: AgentBatchView;
	applied?: number /* int */;
	undone?: number /* int */;
	skipped: AgentSkip[];
	leftOut?: number /* int */;
}
/**
 * AgentSkip is one act an apply or an undo left as it was: its number and why (Reason*).
 */
export interface AgentSkip {
	n: number /* int */;
	reason: string;
}
/**
 * BatchChanged is drive.batch.changed's payload, on the batch's drive: a batch was opened, grew,
 * was decided, withdrawn or undone. It names the batch and its state, never an act or a note, and a
 * page that lists the drive's batches reads them again.
 */
export interface BatchChanged {
	key: string;
	spaceId: number /* int64 */;
	state: string;
}
/**
 * ChangeBatch is the batch a line of an item's Activity belongs to: its key and how many changes it
 * holds ("one of 14 changes").
 */
export interface ChangeBatch {
	key: string;
	count: number /* int */;
}

//////////
// source: events.go

/**
 * SpaceLeft tells a person that a space is no longer theirs to open: an owner group was removed, or
 * the space was archived.
 */
export interface SpaceLeft {
	spaceId: number /* int64 */;
}
/**
 * ItemLeft is published on an item's old space when it moved into another, so a listing of the old
 * space drops it; the new space hears drive.item.changed.
 */
export interface ItemLeft {
	itemId: number /* int64 */;
	spaceId: number /* int64 */;
}
/**
 * StarChanged tells the person who starred or unstarred an item, in every tab of theirs.
 */
export interface StarChanged {
	itemId: number /* int64 */;
	starred: boolean;
}

//////////
// source: file.go

/**
 * The formats a document downloads in (GET /api/drive/items/{key}/download?format=, and the zip's
 * format for the documents inside it). A document downloads as Word unless asked otherwise.
 */
export const FormatDocx = "docx";
/**
 * The formats a document downloads in (GET /api/drive/items/{key}/download?format=, and the zip's
 * format for the documents inside it). A document downloads as Word unless asked otherwise.
 */
export const FormatMd = "md";
/**
 * The formats a document downloads in (GET /api/drive/items/{key}/download?format=, and the zip's
 * format for the documents inside it). A document downloads as Word unless asked otherwise.
 */
export const FormatHTML = "html";
/**
 * The formats a document downloads in (GET /api/drive/items/{key}/download?format=, and the zip's
 * format for the documents inside it). A document downloads as Word unless asked otherwise.
 */
export const FormatTxt = "txt";
/**
 * FileView is a file's current version as a listing shows it: its number, how many versions are
 * visible, and the attachment that holds its bytes.
 */
export interface FileView {
	version: number /* int */;
	versions: number /* int */;
	attachment: core.AttachmentWire;
}
/**
 * VersionView is one visible version of a file: N counts from 1 and is never reused; UploadName is
 * the name it was uploaded under; RestoredFrom names the version a restore copied.
 */
export interface VersionView {
	n: number /* int */;
	uploadName: string;
	restoredFrom?: number /* int */;
	by: number /* int64 */;
	at: number /* int64 */;
	attachment: core.AttachmentWire;
}
/**
 * VersionCutView is an owner's deletion of a file's versions below Before: how many it hid, who and
 * when, and until when it can be undone (PurgeAfter).
 */
export interface VersionCutView {
	id: number /* int64 */;
	before: number /* int */;
	versions: number /* int */;
	by: number /* int64 */;
	at: number /* int64 */;
	purgeAfter: number /* int64 */;
}
/**
 * VersionList answers GET /api/drive/items/{key}/versions: the visible versions, newest first, and
 * the cuts still in their undo window.
 */
export interface VersionList {
	versions: VersionView[];
	cuts: VersionCutView[];
}
/**
 * AddVersion is POST /api/drive/items/{key}/versions: the uploaded attachment becomes the newest
 * version.
 */
export interface AddVersion {
	attachment: number /* int64 */;
}
/**
 * CutVersions is POST /api/drive/items/{key}/versions/cut: delete every version below Before, which
 * lies between 2 and the current version.
 */
export interface CutVersions {
	before: number /* int */;
}
/**
 * VersionCutAnswer answers CutVersions: the file as it now stands and the cut, with its undo window.
 */
export interface VersionCutAnswer {
	item: ItemView;
	cut: VersionCutView;
}
/**
 * PurgePreview answers GET /api/drive/items/{key}/purge and GET /api/admin/drive/items/{key}/purge:
 * what deleting a trashed item for good would take — its kind, how many items, how many bytes, when
 * it was trashed — and, for a team member of its drive, its name, which the confirm names. The
 * administrators' preview never carries the name: the administrator who purges is mostly not in the
 * drive.
 */
export interface PurgePreview {
	kind: string;
	name?: string;
	items: number /* int */;
	bytes: number /* int64 */;
	trashedAt: number /* int64 */;
}
/**
 * PurgeResult answers POST /api/drive/items/{key}/purge and POST /api/admin/drive/items/{key}/purge:
 * what went, and how many attachments stayed because something outside the purge still holds them.
 */
export interface PurgeResult {
	items: number /* int */;
	attachments: number /* int */;
	documents: number /* int */;
	sharedElsewhere: number /* int */;
}

//////////
// source: import.go

/**
 * ImportNote is one line of what the conversion could not carry across as it was: Count occurrences
 * of Construct, each treated as Code. The words are core's conversion vocabulary
 * (internal/core/docs/convert/notes), spelled here as strings because the drive imports no part of the
 * document engine; the browser names each in the import banner.
 */
export interface ImportNote {
	code: string;
	construct: string;
	count: number /* int */;
}
/**
 * ImportView answers POST /api/drive/items/{key}/import: the item, now a document under the same key,
 * the conversion's notes, and what the file brought beside its text — the comment threads still open
 * and the suggestions (the hunks of the drafts its tracked changes became) — which the page says once.
 */
export interface ImportView {
	item: ItemView;
	notes: ImportNote[];
	threads: number /* int */;
	suggestions: number /* int */;
}

//////////
// source: item.go

/**
 * The kinds of item (ItemView.Kind, CreateItem.Kind).
 */
export const KindFolder = "folder";
/**
 * The kinds of item (ItemView.Kind, CreateItem.Kind).
 */
export const KindDocument = "document";
/**
 * The kinds of item (ItemView.Kind, CreateItem.Kind).
 */
export const KindFile = "file";
/**
 * What a create does when a live sibling already holds the name (CreateItem.OnConflict): a folder
 * merges into the oldest one of that name; a file becomes a new version of it, or a second file
 * beside it under a free name. Without one, a file's clash is refused error.drive.nameTaken; a
 * document's or a folder's name is never a clash.
 */
export const OnConflictMerge = "merge";
/**
 * What a create does when a live sibling already holds the name (CreateItem.OnConflict): a folder
 * merges into the oldest one of that name; a file becomes a new version of it, or a second file
 * beside it under a free name. Without one, a file's clash is refused error.drive.nameTaken; a
 * document's or a folder's name is never a clash.
 */
export const OnConflictVersion = "version";
/**
 * What a create does when a live sibling already holds the name (CreateItem.OnConflict): a folder
 * merges into the oldest one of that name; a file becomes a new version of it, or a second file
 * beside it under a free name. Without one, a file's clash is refused error.drive.nameTaken; a
 * document's or a folder's name is never a clash.
 */
export const OnConflictKeepBoth = "keep_both";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeCreate = "create";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeRename = "rename";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeMove = "move";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeVersion = "version";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeVersionRestore = "version_restore";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeVersionCut = "version_cut";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeVersionCutUndo = "version_cut_undo";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeVersionPurge = "version_purge";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeTrash = "trash";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeRestore = "restore";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeCopy = "copy";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangeImport = "import";
/**
 * The ops of an item's Activity (ChangeView.Op): each has its sentence, drive.change.<op>, in the
 * browser's catalogue. ChangeOps lists them, so the browser derives its sentences from one set.
 */
export const ChangePurge = "purge";
/**
 * ChangeLink is a document's link outside teamBase turned on, off, to another level or given a
 * new address; its data is the levels before and after and whether the address is new. It has
 * three sentences, drive.change.link_on, _off and _reset, chosen by the browser from the data.
 */
export const ChangeLink = "link";
/**
 * ChangeAgents is an item's own setting for AI chats changed; its data is the settings before and
 * after (inherit, none, read, suggest, write), which drive.change.agents names, and pin: true when
 * an agent's move wrote it to keep the item's reach from widening, which drive.change.agents.pin
 * names with the folder the item left (FromKey).
 */
export const ChangeAgents = "agents";
/**
 * The rules a purge ran under, the "rule" of its Activity data and of its line in drive-purges.jsonl:
 * absent for an administrator's purge, PurgeRuleMember for a team member's *Delete for good* and
 * PurgeRuleExpired for the trash's own deletion three years after the item went there. The browser
 * chooses the purge's sentence by it: drive.change.purge, .purge_member or .expire. Stored words:
 * every later release reads them.
 */
export const PurgeRuleMember = "member";
/**
 * The rules a purge ran under, the "rule" of its Activity data and of its line in drive-purges.jsonl:
 * absent for an administrator's purge, PurgeRuleMember for a team member's *Delete for good* and
 * PurgeRuleExpired for the trash's own deletion three years after the item went there. The browser
 * chooses the purge's sentence by it: drive.change.purge, .purge_member or .expire. Stored words:
 * every later release reads them.
 */
export const PurgeRuleExpired = "expired";
/**
 * ItemView is an item as a reader sees it in a listing, and the payload of drive.item.changed.
 */
export interface ItemView {
	id: number /* int64 */;
	key: string;
	spaceId: number /* int64 */;
	/**
	 * ParentID is the folder the item is in; 0 is the space's root.
	 */
	parentId: number /* int64 */;
	kind: string; // KindFolder, KindDocument or KindFile
	name: string;
	/**
	 * NameAuto marks a document's name taken from its first line, which a typed title replaces.
	 */
	nameAuto?: boolean;
	changedAt: number /* int64 */;
	changedBy: number /* int64 */;
	/**
	 * Trashed is set while the item is in the trash, Purged once an administrator removed it for good.
	 */
	trashed?: TrashView;
	purged?: boolean;
	file?: FileView; // a file's current version
	doc?: DocFacts; // a document's facts for the reader
	/**
	 * Originals counts a document's kept uploads: the files it was opened from.
	 */
	originals?: number /* int */;
	starred: boolean;
	/**
	 * LinkID is a document's address, /drive/<link id> (32 hex), which the page moves a member to
	 * from /drive/<key>; LinkLevel is its link outside teamBase: "off", "view", "comment" or
	 * "edit". Read with the listing, as the facts are; never on drive.item.changed.
	 */
	linkId?: string;
	linkLevel?: string;
	/**
	 * AgentLevel is the item's effective setting for AI chats — "none", "read", "suggest" or "write",
	 * the lowest on its path from the drive's top down to the item — before the drive's own switch
	 * for AI chats, which the space carries. AgentOwn is what the item says itself: "inherit" or one
	 * of the four. AgentFrom is the key of the place the effective setting comes from: the nearest
	 * folder or item that says it, or the drive's own key. All three are read with the listing, never
	 * on drive.item.changed.
	 */
	agentLevel?: string;
	agentOwn?: string;
	agentFrom?: string;
}
/**
 * TrashView is an item's place in the trash: when and by whom, for whom when an AI chat put it there
 * (the person who asked; absent for a person's own trash), the root of what was trashed with it, how
 * many items that root took along, and Until, the moment the trash deletes it for good (At plus the
 * three years the trash keeps it), so the rule's length lives on the server alone. Until is always
 * sent; it is optional on the wire only so a view a page builds for itself needs no date.
 */
export interface TrashView {
	at: number /* int64 */;
	by: number /* int64 */;
	for?: number /* int64 */;
	root: number /* int64 */;
	items: number /* int */;
	until?: number /* int64 */;
}
/**
 * PathEntry is one step of an item's breadcrumb: the space, then each folder down to the item.
 */
export interface PathEntry {
	key: string;
	name: string;
}
/**
 * Resolved answers GET /api/drive/resolve/{key}: what an address names. A space's key leaves Item
 * empty; a document's carries the id the document page opens by. The key of a document's tab other
 * than its first answers the document with Tab, the key the page opens with ?tab=; a removed tab's
 * too, which the page shows read-only.
 */
export interface Resolved {
	space: SpaceView;
	item?: ItemView;
	path: PathEntry[];
	docId?: number /* int64 */;
	tab?: string;
}
/**
 * ItemDetail answers GET /api/drive/items/{key}: the item, its path and its space.
 */
export interface ItemDetail {
	item: ItemView;
	path: PathEntry[];
	space: SpaceView;
}
/**
 * Children answers GET /api/drive/children/{key}: one page of a folder's or a space root's live
 * children in name order; Next is the opaque cursor of the next page, absent on the last.
 */
export interface Children {
	items: ItemView[];
	next?: string;
}
/**
 * CreateItem is POST /api/drive/items: a folder, a document or a file under Parent (a space's or a
 * folder's key). A file names its uploaded Attachment; Name is optional for a document, which then
 * takes its first line. Tree, for a document only, is its content at birth: text this device kept
 * that the person makes a new document of (S-03 Appendix H's *Make it a new document*), a whole
 * document's JSON as the browser holds it, checked by the documents' own rules.
 */
export interface CreateItem {
	parent: string;
	kind: string;
	name?: string;
	attachment?: number /* int64 */;
	onConflict?: string;
	tree?: unknown;
}
/**
 * RenameItem is PATCH /api/drive/items/{key}. Auto marks a document's name taken from its first line
 * rather than typed.
 */
export interface RenameItem {
	name: string;
	auto?: boolean;
}
/**
 * CopyItem is POST /api/drive/items/{key}/copy: the copy goes into To (the source's folder when
 * absent) under Name ("Copy of …" when absent). Rev names the revision of a document to copy —
 * Version history's *Make a copy* of an earlier version —, its head when absent; only a document's
 * copy names one. A document's copy holds every live tab; the key of a tab other than the first
 * copies that tab alone, as a one-tab document, and a revision is always one tab's.
 */
export interface CopyItem {
	to?: string;
	name?: string;
	rev?: number /* int64 */;
}
/**
 * ItemKeys is the body of a trash or a restore: up to 500 keys at once.
 */
export interface ItemKeys {
	keys: string[];
}
/**
 * MoveItems is POST /api/drive/items/move: up to 500 keys into To, a space's or a folder's key.
 */
export interface MoveItems {
	keys: string[];
	to: string;
}
/**
 * ItemList is a list of items without paging: the answer of a move or a trash, and the stars.
 */
export interface ItemList {
	items: ItemView[];
}
/**
 * RestoredItems answers POST /api/drive/items/restore: the restored roots, and the keys of the files
 * that came back under a free name because their old one was taken.
 */
export interface RestoredItems {
	items: ItemView[];
	renamed: string[];
}
/**
 * ItemPage is one page of the trash, newest first; More says an older page exists.
 */
export interface ItemPage {
	items: ItemView[];
	more: boolean;
}
/**
 * RecentItem is an item of Recent with the time the reader last opened or changed it.
 */
export interface RecentItem extends ItemView {
	openedAt: number /* int64 */;
}
/**
 * RecentPage answers GET /api/drive/recent, newest first. Reachable is present only on an empty first
 * page: how many items the reader's shared drives hold, so an empty Recent after a migration points at
 * them.
 */
export interface RecentPage {
	items: RecentItem[];
	more: boolean;
	reachable?: number /* int */;
}
/**
 * ChangeView is one line of an item's Activity: what happened (Op, one of ChangeOps), who did it and
 * when. Data is the op's own facts — an old name, a version number, a source — as the op wrote them.
 */
export interface ChangeView {
	id: number /* int64 */;
	itemId: number /* int64 */;
	op: string;
	byline: Byline;
	at: number /* int64 */;
	data: unknown;
	/**
	 * FromKey is, for a move and for the pin an agent's move wrote (op agents, data pin), the key of
	 * the place the item left: a folder's, or a drive's for its root. The browser names it only for a
	 * reader who may open it (the resolve route decides).
	 */
	fromKey?: string;
	/**
	 * Chat names the AI chat an act of Claude's came from — title and address — to a reader who can
	 * open that chat, and to nobody else. Batch is the batch of an AI chat's changes the act belongs
	 * to: Claude's own act, or a person's that applied Claude's proposal ("as Claude proposed").
	 */
	chat?: ChatRef;
	batch?: ChangeBatch;
}
/**
 * ActivityPage answers GET /api/drive/items/{key}/activity, newest first.
 */
export interface ActivityPage {
	changes: ChangeView[];
	more: boolean;
}

//////////
// source: space.go

/**
 * BuiltinTeam is the one built-in shared drive (SpaceView.Builtin): Team, owned by @team, made on the
 * first visit of anyone who may make it.
 */
export const BuiltinTeam = "team";
/**
 * SpaceView is a space as a reader sees it, and the payload of drive.space.changed.
 */
export interface SpaceView {
	id: number /* int64 */;
	key: string;
	name?: string; // empty for a personal space, and for Team until renamed
	personal: boolean;
	builtin?: string; // BuiltinTeam, or empty
	/**
	 * Mine is true on the reader's own My drive. Person and PersonName are a personal space's person
	 * and their display name, so a reader an administrator's rescue let into somebody else's My drive
	 * reads it as theirs ("Anna's drive", worded by the browser).
	 */
	mine: boolean;
	person?: number /* int64 */;
	personName?: string;
	/**
	 * Owners are the owner groups' ids, in the order they were added.
	 */
	owners: number /* int64 */[];
	archived: boolean;
	/**
	 * AgentsClosed marks a drive closed to AI chats; ClosedBy and ClosedAt say who closed it and when.
	 */
	agentsClosed?: boolean;
	closedBy?: number /* int64 */;
	closedAt?: number /* int64 */;
	/**
	 * AgentSetting is the drive's top's setting for AI chats, the most Claude may do anywhere in it
	 * ("none", "read", "suggest" or "write"; every drive starts at write); AgentSetBy and AgentSetAt
	 * say who set it and when, absent while nobody has.
	 */
	agentSetting: string;
	agentSetBy?: number /* int64 */;
	agentSetAt?: number /* int64 */;
	/**
	 * LinksClosed marks a drive whose documents no link outside teamBase opens, whatever each
	 * document's link says; LinksClosedBy and LinksClosedAt say who closed it and when.
	 */
	linksClosed?: boolean;
	linksClosedBy?: number /* int64 */;
	linksClosedAt?: number /* int64 */;
	/**
	 * Members counts the active accounts the owner groups reach.
	 */
	members: number /* int */;
	/**
	 * Items counts the items in the space that are neither in the trash nor purged: a card's
	 * "{count} items", kept by every write and sent again with each change of it.
	 */
	items: number /* int */;
}
/**
 * SpaceList answers GET /api/drive/spaces: every space the reader reaches, and whether Team exists
 * yet, so the first visit knows to ask for it.
 */
export interface SpaceList {
	spaces: SpaceView[];
	teamMade: boolean;
}
/**
 * CreateSpace is POST /api/drive/spaces in its three forms: a new shared drive (Name, Groups and the
 * keys to Move into it), the reader's My drive (Personal) or Team (Builtin: BuiltinTeam). The last
 * two are idempotent.
 */
export interface CreateSpace {
	name?: string;
	groups?: number /* int64 */[];
	move?: string[];
	personal?: boolean;
	builtin?: string;
}
/**
 * CreatedSpace answers CreateSpace; Space is null when the reader may not have the space asked for
 * (a guest's My drive).
 */
export interface CreatedSpace {
	space?: SpaceView;
}
/**
 * RenameSpace is PATCH /api/drive/spaces/{key}.
 */
export interface RenameSpace {
	name: string;
}
/**
 * AddOwner is POST /api/drive/spaces/{key}/owners: one more owner group.
 */
export interface AddOwner {
	group: number /* int64 */;
}
/**
 * SetLinks is PUT /api/drive/spaces/{key}/links: open the drive's documents to links outside
 * teamBase again, or close them.
 */
export interface SetLinks {
	open: boolean;
}
/**
 * ReachSide is one side of a move's change of access: how many people, and the first five names.
 */
export interface ReachSide {
	count: number /* int */;
	names: string[];
}
/**
 * ReachChange answers GET /api/drive/spaces/{key}/reach-change: who gains and who loses access when
 * something moves to another space or the groups change, for the dialog to say before it happens.
 */
export interface ReachChange {
	gain: ReachSide;
	lose: ReachSide;
}
/**
 * AdminSpaceView is one row of the administrators' Other shared drives: names, groups and size.
 */
export interface AdminSpaceView {
	key: string;
	name: string;
	personal: boolean;
	builtin?: string;
	owners: number /* int64 */[];
	items: number /* int */;
	bytes: number /* int64 */;
	createdAt: number /* int64 */;
	archived: boolean;
}
/**
 * AdminSpaceList answers GET /api/admin/drive/spaces.
 */
export interface AdminSpaceList {
	spaces: AdminSpaceView[];
}

//////////
// source: types.go
/*
Package wire is the drive's half of the HTTP and event vocabulary (docs/backend/drive.md): every
event type string the drive emits, and one struct per route body, answer and event it shares with
the browser. It is a tygo input (tygo.yaml → web/src/modules/drive/wire/drive.gen.ts), so it holds no
`any` and no behaviour; a payload whose shape belongs to its writer travels as json.RawMessage.

The drive has no socket requests: every act is an HTTP route, and the socket carries only the six
durable events below. Ids inside a view are integers; a key is what an address and a route name.

The subpackage rule of architecture.md D3 applies: wire imports core's leaf packages and nothing of
the module root, and — the drive importing no part of the document engine (S-12-D3) — it spells the
two document shapes it carries, a listing's DocFacts and a writer's Byline, itself.
*/

/**
 * Every drive event type string, in one place. The registrations and the tests use these constants;
 * a type name written as a string literal outside a wire package fails TestNoLiteralWireTypes.
 * Each is durable, on the scope (drive, space id) unless its comment names another audience: a client
 * that was away hears it again on catch-up, and it carries ids, names and counts — never a word of a
 * document, which travels on core's doc.* events and routes.
 */
export const TypeDriveSpaceChanged = "drive.space.changed"; // SpaceView: created, renamed, owners, archive, restore, the AI-chat and links switches
/**
 * Every drive event type string, in one place. The registrations and the tests use these constants;
 * a type name written as a string literal outside a wire package fails TestNoLiteralWireTypes.
 * Each is durable, on the scope (drive, space id) unless its comment names another audience: a client
 * that was away hears it again on catch-up, and it carries ids, names and counts — never a word of a
 * document, which travels on core's doc.* events and routes.
 */
export const TypeDriveSpaceLeft = "drive.space.left"; // SpaceLeft, to each person who lost reach
/**
 * Every drive event type string, in one place. The registrations and the tests use these constants;
 * a type name written as a string literal outside a wire package fails TestNoLiteralWireTypes.
 * Each is durable, on the scope (drive, space id) unless its comment names another audience: a client
 * that was away hears it again on catch-up, and it carries ids, names and counts — never a word of a
 * document, which travels on core's doc.* events and routes.
 */
export const TypeDriveItemChanged = "drive.item.changed"; // ItemView: create, rename, move, trash, restore, versions, import, purge
/**
 * Every drive event type string, in one place. The registrations and the tests use these constants;
 * a type name written as a string literal outside a wire package fails TestNoLiteralWireTypes.
 * Each is durable, on the scope (drive, space id) unless its comment names another audience: a client
 * that was away hears it again on catch-up, and it carries ids, names and counts — never a word of a
 * document, which travels on core's doc.* events and routes.
 */
export const TypeDriveItemLeft = "drive.item.left"; // ItemLeft, on the old space when an item moved to another
/**
 * Every drive event type string, in one place. The registrations and the tests use these constants;
 * a type name written as a string literal outside a wire package fails TestNoLiteralWireTypes.
 * Each is durable, on the scope (drive, space id) unless its comment names another audience: a client
 * that was away hears it again on catch-up, and it carries ids, names and counts — never a word of a
 * document, which travels on core's doc.* events and routes.
 */
export const TypeDriveStarChanged = "drive.star.changed"; // StarChanged, to the person who starred
/**
 * Every drive event type string, in one place. The registrations and the tests use these constants;
 * a type name written as a string literal outside a wire package fails TestNoLiteralWireTypes.
 * Each is durable, on the scope (drive, space id) unless its comment names another audience: a client
 * that was away hears it again on catch-up, and it carries ids, names and counts — never a word of a
 * document, which travels on core's doc.* events and routes.
 */
export const TypeDriveBatchChanged = "drive.batch.changed"; // BatchChanged: an AI chat's batch of changes opened, grew, was decided, withdrawn or undone
/**
 * KeyPattern is a space's or an item's key as one expression — core/keys' alphabet and length — for
 * the browser's route table, which tells an address that may name something from one that cannot
 * before it asks the server. A malformed key, an unknown one and one the reader cannot reach all end
 * on the same page.
 */
export const KeyPattern = `^[2-9a-hjkmnp-z]{8}\$`;
/**
 * PathPrefix is where the drive lives in the browser: PathPrefix alone opens Recent, PathPrefix + "/"
 * + a key opens a space, a folder, a document or a file.
 */
export const PathPrefix = "/drive";
/**
 * The writers a byline names (Byline.Via), as core's documents spell them.
 */
export const ViaBrowser = "browser"; // a person's tab
/**
 * The writers a byline names (Byline.Via), as core's documents spell them.
 */
export const ViaHTTP = "http"; // a person's act on the server
/**
 * The writers a byline names (Byline.Via), as core's documents spell them.
 */
export const ViaTool = "tool"; // an AI chat's call, on behalf of the person who asked
/**
 * The writers a byline names (Byline.Via), as core's documents spell them.
 */
export const ViaSystem = "system"; // the server itself, the Google migration among it
/**
 * Byline is who did something: the person (or Claude), whom Claude acted for, through what (Via*),
 * and for a tool the chat. An item's Activity and a listing's last change are drawn from it.
 */
export interface Byline {
	user: number /* int64 */;
	onBehalf?: number /* int64 */;
	via: string;
	chat?: number /* int64 */;
}
/**
 * DocFacts is what a listing shows about one document for its reader, as core's Docs.Facts answers
 * it: the rev and who changed it last, its first line, its open threads and suggestions, and whether
 * it changed since the reader last looked.
 */
export interface DocFacts {
	rev: number /* int64 */;
	changedAt: number /* int64 */;
	changedBy: Byline;
	firstLine: string;
	openThreads: number /* int */;
	openSuggestions: number /* int */;
	changedSinceSeen: boolean;
}
